import React from 'react';
import { Link } from 'react-router-dom';
import { imageHelpers } from '../../services/api.js';

/**
 * HeroItemsGrid Component
 * Displays responsive grid of hero images from database
 * Up to 5 columns, items expand to fill available width
 * Images are clickable if they have a linkURL
 */
const HeroItemsGrid = ({ heroItems = [] }) => {
  if (!heroItems || heroItems.length === 0) {
    return null;
  }

  // Calculate column class based on number of items (up to 5 columns)
  const getColumnClass = (itemCount) => {
    if (itemCount === 1) return 'col-12';
    if (itemCount === 2) return 'col-12 col-md-6';
    if (itemCount === 3) return 'col-12 col-md-4';
    if (itemCount === 4) return 'col-12 col-sm-6 col-lg-3';
    return 'col-12 col-sm-6 col-md-4 col-lg'; // 5 items - equal width on lg+
  };

  const columnClass = getColumnClass(heroItems.length);

  return (
    <div className="hero-grid">
      <div className="row g-3 g-md-4">
        {heroItems.map((item) => {
          const imageUrl = item.image?.fullPath
            ? imageHelpers.getImageUrl(`/storefront-heroes/${item.image.fullPath}`)
            : null;

          if (!imageUrl) return null;

          const imageElement = (
            <div className="hero-grid__image-wrapper">
              <img
                src={imageUrl}
                alt={item.image?.alt || 'Hero promotional image'}
                className="hero-grid__image img-fluid"
                loading="lazy"
              />
              <div className="hero-grid__overlay"></div>
            </div>
          );

          const isInternal = item.linkURL?.startsWith('/');

          return (
            <div key={item.id} className={columnClass}>
              {item.linkURL ? (
                isInternal ? (
                  <Link to={item.linkURL} className="hero-grid__link">
                    {imageElement}
                  </Link>
                ) : (
                  <a
                    href={item.linkURL}
                    className="hero-grid__link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {imageElement}
                  </a>
                )
              ) : (
                imageElement
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default HeroItemsGrid;